import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RegisterService } from '../proxy/planning/controllers/register.service';

FieldBuilder.setNamespace('Planning');

export const REGISTERVALUE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('deedValue', 'Entity.RegisterValue.DeedValue')
    .decimal()
    .build(),
  FieldBuilder
    .number('fiscalValue', 'Entity.RegisterValue.FiscalValue')
    .decimal()
    .build(),
  FieldBuilder
    .date('valueDate', 'Entity.RegisterValue.ValueDate')
    .required()
    .build(),
  FieldBuilder
    .checkbox('isLastValue', 'Entity.RegisterValue.IsLastValue')
    .build(),
  FieldBuilder.foreignKey(
    'registerId',
    'Entity.Register',
    RegisterService
  )
    .displayFromNested('register.name')
    .sortBy('register.name')
    .build(),
];

export const REGISTERVALUE_CONFIG = {
  entityName: 'RegisterValue',
  localizationKey: 'Planning::Entity.RegisterValue',
  fields: REGISTERVALUE_FIELDS,
  permission: 'PlanningLocation.RegisterValues',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
